import React from 'react';
import classnames from 'classnames';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import styles from './styles';
const useStyles = createUseStyles(styles, 'AbsoluteView');

const AbsoluteView = ({ className, emptyImage, title, subtitle, button }) => {
    const classes = useStyles();

    return (
        <div className={classnames(classes.root, className)}>
            {emptyImage && <div className={classes.imageContainer}>{emptyImage}</div>}
            <div className={classes.content}>
                {title && (
                    <Text type="subtitleLg" bold className={classes.title}>
                        {title}
                    </Text>
                )}
                {subtitle && (
                    <Text type="caption" className={classes.subtitle}>
                        {subtitle}
                    </Text>
                )}
            </div>
            {button && <div className={classes.buttonContainer}>{button}</div>}
        </div>
    );
};

export default AbsoluteView;
